import { ComparerParam } from '@/types/comparer';
import { TableCell, TableRow, Typography, useTheme } from '@mui/material';
import type { FC } from 'react';
import { isEmptyDisplayValue } from '../comparerUtils/comparerUtils';

type HeaderModifiedPropsProps = {
  param: ComparerParam;
};

const HeaderModifiedProps: FC<HeaderModifiedPropsProps> = ({ param }) => {
  const theme = useTheme();
  const colorA = param.changed && !isEmptyDisplayValue(param.oldValue) ? 'error.main' : 'text.primary';
  const colorB = param.changed && !isEmptyDisplayValue(param.newValue) ? 'success.main' : 'text.primary';

  return (
    <TableRow sx={{ bgcolor: theme.palette.action.hover }}>
      <TableCell size='small' sx={{ pl: 10 }}>
        <Typography variant='caption' color='text.secondary'>
          {param.key}
        </Typography>
      </TableCell>
      <TableCell size='small' sx={{ color: colorA }}>
        {isEmptyDisplayValue(param.oldValue) ? '-' : String(param.oldValue)}
      </TableCell>
      <TableCell size='small' sx={{ color: colorB }}>
        {isEmptyDisplayValue(param.newValue) ? '-' : String(param.newValue)}
      </TableCell>
    </TableRow>
  );
};

export default HeaderModifiedProps;
